import { MatPaginator } from '@angular/material/paginator';
import { select, Store } from '@ngrx/store';
import { debounceTime } from 'rxjs/operators';
import { BaseDataSource, QueryResultsModel } from '../../../../../../core/_base/crud';
import { AppState } from '../../../../../../core/reducers';
import { AffiliationRelation } from '../models';
import {
  selectAffiliationRelationPage,
  selectAffiliationRelationPageLoading,
  selectAffiliationRelationShowInitWaitingMessage,
} from '../selectors';

export class AffiliationRelationDataSource extends BaseDataSource {
  private _affiliationRelations: AffiliationRelation[];

  constructor(private store: Store<AppState>, private paginator: MatPaginator) {
    super();
    this.loading$ = this.store.select(selectAffiliationRelationPageLoading);
    this.isPreloadTextViewed$ = this.store.select(selectAffiliationRelationShowInitWaitingMessage);
    this.store
      .pipe(select(selectAffiliationRelationPage), debounceTime(500))
      .subscribe((res: QueryResultsModel) => {
        this._affiliationRelations = res.items;
        this.entitySubject.next(res.items.slice(0, this.paginator.pageSize));
        this.paginatorTotalSubject.next(res.totalCount);
      });
  }

  get affiliationRelations() {
    return this._affiliationRelations;
  }
}
